export default {
      id: "oldcclone-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#oldcclone",
      toString: function () {
        return this.url;
      }
    }